module.exports = __webpack_public_path__ + "img/20231026_160012.287b54ba.png";